import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { BarLoader } from 'react-spinners';
import { GiftItem } from './GiftItem';
import missionImg from '../../../../assets/png/mission_kv.png';
import './FreeGiftTab.scss';
import { toggleModalMission } from '../../../profile/slices/profilePageSlice';
import { useGetGiftTypesBonusQuery } from '../../../../services/api/apiProvider';

export const FreeGiftTab = (): ReactElement => {
  const dispatch = useDispatch();
  const { data: freeGifts, isLoading, refetch } = useGetGiftTypesBonusQuery();

  const showMissionModal = () => {
    dispatch(toggleModalMission(true));
  };

  return (
    <div className="gift-tab">
      {isLoading && (
        <div className="gift-tab__loader">
          <BarLoader color={'#0275d8'} width="100%"></BarLoader>
        </div>
      )}

      {!isLoading && (
        <div className="gift-tab__body">
          {freeGifts && freeGifts.length > 0 ? (
            <>
              <div className="list-gift">
                {freeGifts.map((item) => (
                  <GiftItem
                    key={item.giftType.id}
                    gift={item.giftType}
                    giftBaggage={item.baggage}
                    refetch={() => refetch()}
                  />
                ))}
              </div>
              <div className="mission-gift-tab__description">
                ※ミッションギフトの有効期限は獲得してから24時間です有効期限は先に獲得したギフトから順に表示されます
              </div>
            </>
          ) : (
            <div className="mission-gift-tab__info">
              <img className="mission-gift-tab__info-img" src={missionImg} />
              <p className="mission-gift-tab__info-text">
                ミッションをクリアして限定ギフトをゲットしよう！
              </p>
              <div className="d-flex justify-content-center">
                <div
                  className="mission-gift-tab__show-mission-btn"
                  onClick={showMissionModal}
                >
                  ミッション確認
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
